import { createFileRoute, Outlet, useMatch, useNavigate } from '@tanstack/react-router'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { PageEditHeader } from '@/components/PageEditHeader'
import { Tab, TabList, TabPanel, Tabs } from '@/components/Tabs'

export const Route = createFileRoute('/usage-statistics')({
  component: Component,
})

const ENGAGEMENT_VIEW = 'engagement'
const PREFERENCES_VIEW = 'preferences'

function Component() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const selectedView = useMatch({ from: '/usage-statistics/engagement', shouldThrow: false })
    ? ENGAGEMENT_VIEW
    : PREFERENCES_VIEW

  return (
    <>
      <PageEditHeader title={t('usageStats.title')} />
      <Tabs
        selectedKey={selectedView}
        onSelectionChange={(key) => navigate({ to: `/usage-statistics/${key}` })}>
        <TabList>
          <Tab id={ENGAGEMENT_VIEW}>Engagement</Tab>
          <Tab id={PREFERENCES_VIEW}>Preferences</Tab>
        </TabList>
        <TabPanel id={selectedView}>
          <Outlet />
        </TabPanel>
      </Tabs>
    </>
  )
}
